import Vue from 'vue';
import VueI18n from 'vue-i18n';
import nl from './locales/nl';

Vue.use(VueI18n);

const i18n = new VueI18n({
	locale: 'nl',
	messages: {
		nl
	}
});

export default i18n;



// WEBPACK FOOTER //
// ./src/language/index.js